import moment from "moment";

export const VALID_DELIVERY_SERVICE_LEVELS = ["1", "3", "5", "7", "NA"] as const;
export type DeliveryServiceLevelValue = (typeof VALID_DELIVERY_SERVICE_LEVELS)[number];

const NUMERIC_LEVELS = new Set(["1", "3", "5", "7"]);

export function isDeliveryServiceLevelFeatureActive(
  serviceLevelsEnabled: boolean,
  stopCount: number,
): boolean {
  return serviceLevelsEnabled === true && stopCount === 2;
}

export function isNumericDeliveryServiceLevel(value: string | null | undefined): boolean {
  return value != null && NUMERIC_LEVELS.has(value);
}

export function computeDeliveryAfterDateFromServiceLevel(
  pickupAfterDate: string | null | undefined,
  serviceLevel: string | null | undefined,
): string | null {
  if (!pickupAfterDate || !isNumericDeliveryServiceLevel(serviceLevel)) return null;
  return moment(pickupAfterDate).add(Number(serviceLevel), "days").format("YYYY-MM-DD");
}

/** Show delivery datetime when level is NA, or numeric level with pickup date set. */
export function shouldShowDeliveryDatetimeFields(
  showServiceLevelSelect: boolean,
  serviceLevel: string | null | undefined,
  hasPickupDate: boolean,
): boolean {
  if (!showServiceLevelSelect) return true;
  if (!serviceLevel) return false;
  if (serviceLevel === "NA") return true;
  return hasPickupDate;
}

/** Numeric levels need pickup date to compute delivery; NA has no such dependency. */
export function shouldShowPickupDateRequiredMessage(
  showServiceLevelSelect: boolean,
  serviceLevel: string | null | undefined,
  hasPickupDate: boolean,
): boolean {
  return showServiceLevelSelect && isNumericDeliveryServiceLevel(serviceLevel) && !hasPickupDate;
}

/** Numeric service levels compute delivery date; date and time-type stay visible but locked. */
export function isDeliveryDatetimeLockedByServiceLevel(
  showServiceLevelSelect: boolean,
  serviceLevel: string | null | undefined,
): boolean {
  return showServiceLevelSelect && isNumericDeliveryServiceLevel(serviceLevel);
}
